var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBallot = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_187_75",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_187_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 10C16.2833 10 16.5208 9.90417 16.7125 9.7125C16.9042 9.52083 17 9.28333 17 9C17 8.71667 16.9042 8.47917 16.7125 8.2875C16.5208 8.09583 16.2833 8 16 8H13C12.7167 8 12.4792 8.09583 12.2875 8.2875C12.0958 8.47917 12 8.71667 12 9C12 9.28333 12.0958 9.52083 12.2875 9.7125C12.4792 9.90417 12.7167 10 13 10H16ZM16 16C16.2833 16 16.5208 15.9042 16.7125 15.7125C16.9042 15.5208 17 15.2833 17 15C17 14.7167 16.9042 14.4792 16.7125 14.2875C16.5208 14.0958 16.2833 14 16 14H13C12.7167 14 12.4792 14.0958 12.2875 14.2875C12.0958 14.4792 12 14.7167 12 15C12 15.2833 12.0958 15.5208 12.2875 15.7125C12.4792 15.9042 12.7167 16 13 16H16ZM9 11C9.55 11 10.0208 10.8042 10.4125 10.4125C10.8042 10.0208 11 9.55 11 9C11 8.45 10.8042 7.97917 10.4125 7.5875C10.0208 7.19583 9.55 7 9 7C8.45 7 7.97917 7.19583 7.5875 7.5875C7.19583 7.97917 7 8.45 7 9C7 9.55 7.19583 10.0208 7.5875 10.4125C7.97917 10.8042 8.45 11 9 11ZM9 17C9.55 17 10.0208 16.8042 10.4125 16.4125C10.8042 16.0208 11 15.55 11 15C11 14.45 10.8042 13.9792 10.4125 13.5875C10.0208 13.1958 9.55 13 9 13C8.45 13 7.97917 13.1958 7.5875 13.5875C7.19583 13.9792 7 14.45 7 15C7 15.55 7.19583 16.0208 7.5875 16.4125C7.97917 16.8042 8.45 17 9 17ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBallot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ballot.adc38b4798d4aba8a2cee3d8f7195a15.svg";